import messages, { LanguageKey } from '@/translations/messages'
import { getLocalLanguage } from '@/services/language'

const language = getLocalLanguage()

export const getMessage = (id: LanguageKey): string =>
  messages?.[language]?.[id] || id

export { messages }
